import { Input, Form as AntdForm } from "antd"
import { ErrorAlert } from "components/atoms/Alert"
import { Button } from "components/atoms/Button"
import { Spin } from "components/atoms/Spin"
import {
  Form,
  FormItem,
  FormTitle,
  FormItemCenter,
} from "components/atoms/form"
import {
  useFetchClient,
  useInitializeAccountData,
} from "hooks/useInitializeAccountData"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { clientState } from "recoils/clientState"
import styled from "styled-components"
import { upsertClientProfile } from "usecases/firebase/functions"

import type { ClientUpsert } from "interfaces/ClientIF"

const StyledButton = styled(Button)`
  min-width: 6rem;
`
export const ProfileEditPage: React.VFC = () => {
  const navigate = useNavigate()
  const [error, setError] = useState("")
  const [loading, asyncLoading] = useAsyncLoading("profileEdit")
  const [form] = AntdForm.useForm()
  const client = useRecoilValue(clientState)
  const fetchClient = useFetchClient()
  const initialize = useInitializeAccountData()
  useEffect(() => {
    asyncLoading(
      initialize()
        .then(() => {
          form.resetFields()
        })
        .catch((e) => setError(e.message)),
    )
    // MEMO: 初回描画のみ実行する
  }, [])
  const onFinish = (values: unknown) => {
    asyncLoading(
      upsertClientProfile({
        name: (values as ClientUpsert).name,
        furigana: (values as ClientUpsert).furigana,
        position: (values as ClientUpsert).position,
      })
        .then(async () => {
          await fetchClient()
          navigate("/profile")
        })
        .catch((e) => {
          setError(e.message)
        }),
    )
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo)
  }
  return loading ? (
    <Spin />
  ) : (
    <>
      <Form
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={client}
        layout="vertical"
        requiredMark={false}
        form={form}
      >
        <FormTitle>プロフィール編集</FormTitle>

        <FormItem
          label="氏名"
          name="name"
          required
          rules={[{ required: true, message: "氏名を入力してください" }]}
        >
          <Input maxLength={100} />
        </FormItem>

        <FormItem
          label="フリガナ"
          name="furigana"
          required
          rules={[{ required: true, message: "フリガナを入力してください" }]}
        >
          <Input maxLength={100} />
        </FormItem>

        <FormItem
          label="役職"
          name="position"
          required
          rules={[{ required: true, message: "役職を入力してください" }]}
        >
          <Input disabled={loading} maxLength={100} />
        </FormItem>

        {error && <ErrorAlert>{error}</ErrorAlert>}
        <FormItemCenter>
          <StyledButton
            isLoading={loading}
            className={"primary"}
            htmlType="submit"
          >
            保存
          </StyledButton>
        </FormItemCenter>
      </Form>
    </>
  )
}
